import {DemoStepAction, DemoStepActionType} from '../demoStepAction';

export class ActionEnableJokers implements DemoStepAction {
    type: DemoStepActionType = DemoStepActionType.ENABLE_JOKERS;
}
